import { useSelector } from "react-redux";
import store from "../storeWire";
import {
    getAlertListingByType,
    getStockAlertListing,
    getAlertCount,
} from "../store/slice/model/Alert";
import AlertRepository from "src/repository/AlertRepository";
import { __remove, __set } from "src/store/axios_indicator";

export function useAlertStore() {
    const PCNAlertListingByType = useSelector((state) => state.entities.model_Alert.PCNAlertListingByType)
    const EOLAlertListingByType = useSelector((state) => state.entities.model_Alert.EOLAlertListingByType)
    const StockAlertListingByType = useSelector((state) => state.entities.model_Alert.StockAlertListingByType)
    const alertTabsCount=useSelector((state) => state.entities.model_Alert.alertTabsCount)
    

    
    let data = {
        PCNAlertListingByType,
        EOLAlertListingByType,
        StockAlertListingByType,
        alertTabsCount
    };
    let fetch = {
        get_alert_listing_by_type: async (params) => {
            return await store.dispatch(getAlertListingByType(params))
        },
        get_alert_count:async(params)=>{
            return await store.dispatch(getAlertCount(params));
        },
        get_stock_alert_listing: async (params) => {
            return await store.dispatch(getStockAlertListing(params))
        },
        export_alert_data: async (params) => {
            return await new AlertRepository().exportAlertData(params)
        },
        export_stock_alert_data: async (params) => {
            __set('EXPORT_ALERT_API_CALL');
            let res = await new AlertRepository().exportStockAlertData(params)
            __remove('EXPORT_ALERT_API_CALL');
            return res;
        },
        get_stock_manufacturers: async () => {
            return await new AlertRepository().getStockManufacturers()
        },
        get_stock_alerts_products: async (params) => {
            return await new AlertRepository().getStockAlertProducts(params)
        },
    };
    let set = {
        delete_stock_alert:async (params)=>{
            return await new AlertRepository().deleteStockAlert(params)
        },
    };
    return [data, fetch, set]
}